import React from 'react';
import { ShieldCheckIcon, DocumentTextIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

function Privacy() {
  const privacySections = [
    {
      title: 'Data Collection',
      content: 'We collect information to provide better services to our users. This includes:',
      items: [
        'Basic profile information',
        'Quiz and game performance data',
        'Device and usage information'
      ]
    },
    {
      title: 'Data Usage',
      content: 'Your data is used to:',
      items: [
        'Personalize your learning experience',
        'Track your progress and achievements',
        'Improve our services'
      ]
    },
    {
      title: 'Data Protection',
      content: 'We take your privacy seriously:',
      items: [
        'Encrypted data storage',
        'Secure data transmission',
        'Regular security audits'
      ]
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="p-3 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
            <ShieldCheckIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Privacy Policy
            </h2>
            <p className="text-gray-500 dark:text-gray-400">
              Your privacy is important to us
            </p>
          </div>
        </div>

        <div className="space-y-6">
          {privacySections.map((section, index) => (
            <div key={index} className="space-y-3">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                {section.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                {section.content}
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-300">
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact Information */}
          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <div className="flex items-center space-x-3 text-gray-600 dark:text-gray-300">
              <EnvelopeIcon className="h-5 w-5" />
              <p>For privacy-related inquiries, contact us at: <a href="mailto:support@bountygame.com" className="text-primary-600 dark:text-primary-400 hover:underline">support@bountygame.com</a></p>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Settings */}
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Privacy Settings
        </h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-dark-700 rounded-xl">
            <div className="flex items-center space-x-3">
              <DocumentTextIcon className="h-5 w-5 text-gray-500" />
              <span className="text-gray-900 dark:text-white">
                Data Collection
              </span>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" defaultChecked />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600"></div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy; 